import React from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "@mui/material/Button";
import ReactGA from 'react-ga4'
import logo from '../assets/images/finaculator1.png';
import addWatermark from './watermark';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useState } from "react";



interface SWPPDFGeneratorProps {
  initialInvestment: string;
  monthlyWithdrawal: string;
  rate: string;
  period: string;
  finalBalance: number | null;
  totalWithdrawal: number | null;
  isCalculated?:boolean,

}

const SWPPDFGenerator: React.FC<SWPPDFGeneratorProps> = ({
  initialInvestment,
  monthlyWithdrawal,
  rate,
  period,
  finalBalance,
  totalWithdrawal,
  isCalculated
}) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const generatePDF = () => {
    ReactGA.event({ 'category': 'SWP PDF ', 'action': 'SWP PDF Button', 'label': 'SWP PDF' })

    if (!isCalculated) {
      setSnackbarMessage("Please calculate the values before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
   

    if ( !initialInvestment ||
      !monthlyWithdrawal ||
      !rate ||
      !period ||
      finalBalance === null ||
      totalWithdrawal === null ||
      !isCalculated) {
      setSnackbarMessage("Please ensure all fields are filled before downloading the PDF.");
      setSnackbarOpen(true);
      return;
    }
    

    const doc = new jsPDF();
    const watermarkWidth = 100;
    const watermarkHeight = 100;
    const title = "SWP Investment Summary";
    const titleWidth = doc.getTextWidth(title);
    const pageWidth = doc.internal.pageSize.getWidth();
    const xPosition = (pageWidth - titleWidth) / 2;
    doc.text(title, xPosition, 10);

    const tableColumn = ["Parameter", "Value"];
    const tableRows = [
      ["Total Investment", `${initialInvestment.replace(/,/g, "")}`],
      ["Monthly Withdrawal Amount", `${monthlyWithdrawal.replace(/,/g, "")}`],
      ["Expected Annual Return Rate (%)", rate],
      ["Investment Duration (Years)", period],
      ["Final Balance after Withdrawals", `${finalBalance !== null ? finalBalance.toFixed(2) : "0"}`],
      ["Total Withdrawal Amount", `${totalWithdrawal !== null ? totalWithdrawal.toFixed(2) : "0"}`],
    ];



    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      headStyles: { fillColor: [22, 160, 133] },
      theme: "grid",
    });
    addWatermark(doc, logo, watermarkWidth, watermarkHeight);
    const img = new Image();
    img.src = logo;
    img.onload = () => {
      const now = new Date();
      const padZero = (num: string | number) => ("0" + num).slice(-2);
      const formattedDate = `${now.getFullYear()}-${padZero(now.getMonth() + 1)}-${padZero(now.getDate())}`;
      const formattedTime = `${padZero(now.getHours())}-${padZero(now.getMinutes())}-${padZero(now.getSeconds())}`;
      const timestamp = `${formattedDate}_${formattedTime}`;
      const fileName = `finaculator_swp_calculator_${timestamp}.pdf`;
      doc.save(fileName);
    };
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '10px' }}>
      <Button
        color="success"
        variant="contained"
        onClick={generatePDF}
        startIcon={<DownloadIcon />}
      >
        Download PDF
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} 
      >
        <MuiAlert onClose={handleSnackbarClose} severity="warning" sx={{ width: '100%' }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SWPPDFGenerator;